import { IMPERIAL } from '../constants/uom';

export const formatRadon = (value) => {
  return value && Number(value).toFixed(1);
};

export const formatTemperature = (value) => {
  return value && Number(value).toFixed(0);
};

export const formatPressure = (value) => {
  return value && Number(value).toFixed(1);
};

export const formatHumidity = (value) => {
  return value && Number(value).toFixed(0);
};



// WEBPACK FOOTER //
// src/utils/formatters.js